import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MyContextProvider } from 'reducer/userReducers';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <MyContextProvider>
            <App />
        </MyContextProvider>
    </React.StrictMode>
);

reportWebVitals();
